import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddUserToWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackAddUserToWishList = (
    parameters: TrackAddUserToWishListParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "add_user_to_wishlist", ...parameters }, options);
};

export default trackAddUserToWishList;
